import React from 'react';

export const DaysRemainingIcon = ({ status }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="svg days-remaining"
  >
    <title>Combined Shape</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <filter
        x="-0.7%"
        y="-0.2%"
        width="101.3%"
        height="100.8%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feOffset dx={0} dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.03 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g
        id="Dashboard"
        transform="translate(-616.000000, -787.000000)"
        fill={
          status === 'pending'
            ? '#ffd138'
            : status === 'failed'
            ? 'red'
            : '#a4aac0'
        }
        fillRule="nonzero"
      >
        <g
          id="Cards"
          filter="url(#filter-1)"
          transform="translate(320.000000, 140.000000)"
        >
          <g id={2} transform="translate(0.000000, 364.000000)">
            <g id="Fees">
              <g id="Content">
                <g id="Payment-Card">
                  <g id={1} transform="translate(30.000000, 113.000000)">
                    <g
                      id="days-remaining"
                      transform="translate(269.000000, 170.000000)"
                    >
                      <g id="connection21">
                        <g id="clock100">
                          <path
                            d="M10,20 C4.5,20 0,15.5 0,10 C0,4.5 4.5,0 10,0 C15.5,0 20,4.5 20,10 C20,15.5 15.5,20 10,20 Z M10.5,5 L9,5 L9,11 L12.7006071,13.2894514 L13.5358089,12.0214854 L10.5,10.2 L10.5,5 Z"
                            id="Combined-Shape"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

// <?xml version="1.0" encoding="UTF-8"?>
export const TransactionSuccessIcon = () => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Combined Shape</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <filter
        x="-0.7%"
        y="-0.3%"
        width="101.3%"
        height="101.1%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.03 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Fees"
        transform="translate(-617.000000, -340.000000)"
        fill="#59C203"
      >
        <g
          id="Cards"
          filter="url(#filter-1)"
          transform="translate(320.000000, 140.000000)"
        >
          <g id="Primary-Fees">
            <g id="1">
              <g id="Content" transform="translate(30.000000, 40.000000)">
                <g id="Payment-Card">
                  <g id="1">
                    <g
                      id="days-remaining"
                      transform="translate(270.000000, 158.000000)"
                    >
                      <g
                        id="Check-Box---clicked"
                        transform="translate(0.000000, 2.000000)"
                      >
                        <path
                          d="M0,10 C0,4.4771525 4.47593818,0 10,0 C15.5228475,0 20,4.47593818 20,10 C20,15.5228475 15.5240618,20 10,20 C4.4771525,20 0,15.5240618 0,10 Z M12.4694631,6.82709707 L8.1668694,12.1096788 L6.06976701,9.98951645 L5.35880441,10.6927463 L8.23899429,13.604607 L13.2448226,7.45861722 L12.4694631,6.82709707 Z"
                          id="Combined-Shape"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const CheckedSuccessIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="0 0 26 26"
    enableBackground="new 0 0 26 26"
    width="512px"
    height="512px"
    className
  >
    <g>
      <path
        d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z"
        data-original="#000000"
        className="active-path"
        data-old_color="##00D71"
        fill="#00D715"
      />
    </g>
    {'{'}' '{'}'}
  </svg>
);
